export default __webpack_public_path__ + "static/media/UserPlus.7f61aa2b.svg";